import { fetchBeAppVersion } from './actions/app-version.actions';

const mapStateToThis = ({ backendVersion }) => {
  return { backendVersion };
};

const mapDispatchToThis = {
  fetchBeAppVersion,
};

@Inject('$ngRedux', '$window')
export class RwAppVersionController {
  constructor() {
    this.frontendVersion = $window.FE_VERSION;
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.backendVersion) this.fetchBeAppVersion();
  }

  $onDestroy() {
    this.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/rw-app-version-controller.js